import { Language } from './constants';

/**
 * Maps given locale string to a Language enum value.
 * Defaults to Language.fi.
 * @param locale string to parse the locale from
 * @returns Language
 */
export const mapLocaletoLanguage = (locale: string | undefined): string => {
  if (!locale) {
    return Language.fi;
  }
  // Typical separators between language and its variant are _ and -
  // E.g. op.fi uses _
  const strippedLocale = locale.toLowerCase().split('_')[0].split('-')[0];
  return (
    Object.keys(Language).find(lang => lang === strippedLocale) ?? Language.fi
  );
};

export const mapLanguageToLocale = (language: string): string => {
  const localeMap: { [key: string]: string } = {
    fi: 'fi-FI',
    sv: 'sv-SE',
    en: 'en-US'
  };

  return localeMap[language] || 'fi-FI'; // Default to Finnish if not found
};
